import React from 'react';
import {
  Avatar,
  Typography,
  TableRow,
  TableCell,
  Checkbox,
} from '@material-ui/core';

const ListBusinessUsersItem = ({user, isSelected, toggleEmail}) => {
  const initialLetter = user.name || '';
  return (
    <>
      <TableRow>
        <TableCell>
          <div style={{display: 'flex'}}>
            <Checkbox
              checked={isSelected}
              onChange={() => toggleEmail(user.email)}
            />
            <Avatar alt="Remy Sharp" style={{textTransform: 'uppercase'}}>
              {initialLetter[0]}
            </Avatar>
          </div>
        </TableCell>

        <TableCell>
          <Typography variant="body2" color="textPrimary">
            {user.name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="body2" color="textPrimary">
            {user.email}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="body2" color="textPrimary">
            {user?.business?.corporateName}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ListBusinessUsersItem;
